import Select from 'react-select';

export function SelectSimple({options, handleChange, value, isMulti=false}) {

  const customStyles = {
    option: (defaultStyles, state) => ({
      ...defaultStyles,
      color: '#333',
      backgroundColor: state.isSelected ? "#2684FF" : "#fff",
    }),

    control: (defaultStyles) => ({
      ...defaultStyles,
    }),
    singleValue: (defaultStyles) => ({ ...defaultStyles, color: "#333" }),
  };

  return (
    <div>
      <Select
        isMulti={isMulti}
        styles={customStyles}
        value={value}
        onChange={handleChange}
        options={options}
      />
    </div>
  );
}